// extracted by mini-css-extract-plugin
export default {"microserviceIcon":"SystemIntegration_microserviceIcon__4ZKeM","glowBackground":"SystemIntegration_glowBackground__uW5-h"};